import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Typography from "../../../typography/Typography";

import { CircularStepperStepProps } from "./CircularStepperStep.types";
import StyledCircularStepperStep from "./CircularStepperStep.styles";

const CircularStepperStep: FC<CircularStepperStepProps> = ({
	label,
	text,
	className,
	status = "default",
	colorOn,
	...props
}) => {
	const block = new BemIt("CircularStepperStep");

	return (
		<StyledCircularStepperStep
			className={addClass(className).after(block)}
			status={status}
			{...props}
		>
			<Typography colorOn={colorOn} weight="heaviest">
				{label}
			</Typography>
			{text && (
				<Typography colorOn={colorOn} colorContrast={2} variant="body-small">
					{text}
				</Typography>
			)}
		</StyledCircularStepperStep>
	);
};

export default CircularStepperStep;
